export const determineStepTitle = (currentStep, activePaymentsEnabled, clubDetails, isOwner) => {
    let stepTitle = null;
    let stepSubTitle = null;

    switch (currentStep) {
        case 1:
            stepTitle = 'Start with the basics';
            break;
        case 2:
            stepTitle = 'Set up your divisions';
            break;
        case 3:
            stepTitle = 'Add the details';
            break;
        case 4:
            stepTitle = 'Add Sponsors';
            stepSubTitle = 'This is an optional step. Logo files can be jpgs, gifs, or pngs. Logos should be uploaded with no additional white space (padding) around them.';
            break;
        case 5:
            stepTitle = 'Health & Safety';
            break;
        case 6:
            if (clubDetails.paymentsEnabled && activePaymentsEnabled) {
                stepTitle = 'You’re all set!';
                stepSubTitle = 'You are ready to publish and run paid events.';
            } else if (!isOwner) {
                const organizers = [];
                (clubDetails.clubOrganizers || []).forEach(organizer => {
                    if (organizer.role === 'Owner') {
                        organizers.push(organizer.displayName);
                    }
                });
                stepTitle = 'CONTACT HEAD ORGANIZER TO SET UP PAYMENTS ACCOUNT';
                stepSubTitle = `You need to be a head organizer to set up the payments account for this club. Please contact your head organizer(s), ${organizers.join(', ')}, to have them set this up.`;
            } else {
                stepTitle = 'Set up your payments account';
                stepSubTitle = `Let's make sure you get paid. In order to receive payment, you need to set up a Stripe account.`;
            }
            break;
        default:
            break;
    }

    return { stepTitle, stepSubTitle };
};
